import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
}), 'SubdirectoryArrowRight');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SubdirectoryArrowRight.js
// module id = 6558
// module chunks = 2